import groq from 'groq';

import { INGREDIENTS } from '../blocks/keyIngredients';
import { ASSET, RICH_TEXT } from '../common';

export const PRODUCT_ACCORDION_FIELDS = groq`
  howToUseV2 {
    contentType,
    description[] { ${RICH_TEXT} },
    steps[] {
      title,
      description,
      image {
        ${ASSET}
      }
    }
  },
  benefits -> {
    title,
    description[] { ${RICH_TEXT} },
    disclaimer,
  },
  "ingredients": ingredientsV2 -> { ${INGREDIENTS} },
  informationPanel {
    alt,
    "url": asset -> url,
  }
`;
